var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocialRoomsIconWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7917 51.625V46.7083C41.7917 44.1004 40.7557 41.5992 38.9116 39.7551C37.0675 37.911 34.5663 36.875 31.9584 36.875H12.2917C9.68374 36.875 7.1826 37.911 5.33849 39.7551C3.49438 41.5992 2.45837 44.1004 2.45837 46.7083V51.625",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.125 27.0417C27.5558 27.0417 31.9583 22.6391 31.9583 17.2083C31.9583 11.7775 27.5558 7.375 22.125 7.375C16.6942 7.375 12.2916 11.7775 12.2916 17.2083C12.2916 22.6391 16.6942 27.0417 22.125 27.0417Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5416 51.625V46.7083C56.54 44.5296 55.8148 42.4131 54.48 40.6911C53.1451 38.9691 51.2762 37.7393 49.1666 37.1946",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3334 7.69458C41.4486 8.23615 43.3233 9.4663 44.6621 11.1911C46.001 12.9159 46.7276 15.0372 46.7276 17.2206C46.7276 19.404 46.001 21.5254 44.6621 23.2502C43.3233 24.9749 41.4486 26.2051 39.3334 26.7467",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialRoomsIconWhite);
export default __webpack_public_path__ + "static/media/social-rooms-icon-white.2ae5c79d.svg";
export { ForwardRef as ReactComponent };